import { render } from "./GroupColorPicker.vue?vue&type=template&id=10f703ea&scoped=true"
import script from "./GroupColorPicker.vue?vue&type=script&lang=js"
export * from "./GroupColorPicker.vue?vue&type=script&lang=js"

import "./GroupColorPicker.vue?vue&type=style&index=0&id=10f703ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f703ea"]])

export default __exports__